export const DEMO_PHOTOS = Object.freeze({
  congestion:
    "https://commons.wikimedia.org/wiki/Special:FilePath/A%20Traffic%20Jam%20in%20the%20making%20-%20geograph.org.uk%20-%20426554.jpg",
  potholeRepair:
    "https://commons.wikimedia.org/wiki/Special:FilePath/Windsor%20Road%20Potholes.jpg",
  flooding:
    "https://commons.wikimedia.org/wiki/Special:FilePath/Warwickslade%20Cutting%2C%20temporary%20culvert%20with%20flood%20-%20geograph.org.uk%20-%201565940.jpg",
  roadwork:
    "https://commons.wikimedia.org/wiki/Special:FilePath/Road%20Works%20on%20the%20A43%20-%20geograph.org.uk%20-%20143951.jpg",
});
